<template>
	<div class="body">
		<div class="body-content p-4">
			<div class="eb-body container">
				<div class="course-detail-page__back-link" role="button" @click="$router.push('/user/dashboard')">
					<i class="fas fa-arrow-left"></i> Back to My Courses
				</div>
				<div v-if="loading" class="course-detail-page__skeleton">
					<b-skeleton height="200px" width="100%" class="mb-3"></b-skeleton>
					<b-skeleton height="160px" width="100%"></b-skeleton>
				</div>
				<div v-else-if="productVariant" class="course-detail-page__grid">
					<div class="course-detail-page__overview">
						<CourseOverviewCard
							:productVariant="productVariant"
							:progress="progress"
							:continueURL="courseContentURL"
							:totalModules="totalModules"
						/>
					</div>
					<div class="course-detail-page__sidebar">
						<DashboardUpdatesCard :productVariantId="$route.params.id" />
					</div>
					<div class="course-detail-page__performance">
						<CourseDetailPerformance :productVariantId="$route.params.id" :productVariant="productVariant"/>
					</div>
				</div>
				<div v-else-if="!loading" class="course-detail-page__not-found">
					<i class="fas fa-exclamation-circle"></i>
					<p>Course not found.</p>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import CourseOverviewCard from "../components/ProductContentDashboardSummary/CourseOverviewCard.vue";
import DashboardUpdatesCard from "../components/Dashboard/DashboardUpdatesCard.vue";
import CourseDetailPerformance from "../components/ProductContentDashboardSummary/CourseDetailPerformance.vue";

export default {
	name: "CourseDetailPage",
	components: { CourseOverviewCard, DashboardUpdatesCard, CourseDetailPerformance },
	data() {
		return {
			loading: true,
		};
	},
	async created() {
		const id = this.$route.params.id;

		if (!this.user?.productVariants?.length) {
			await this.fetchCurrentUser();
		}

		const pv = this.user?.productVariants?.find((v) => v.id == id);

		const showPage = pv?.properties?.dashboardPageConfig_showDashboardSummaryPage ? pv?.properties?.dashboardPageConfig_showDashboardSummaryPage.toString().toLowerCase() === "true": false;
		if (!showPage) {
			this.$router.replace(`/product/content/${id}`);
			return;
		}

		if (!this.productVariantsProgress?.[id]) {
			await this.getProductVariantProgress(id);
		}

		this.loading = false;
	},
	methods: {
		...mapActions("user", ["fetchCurrentUser"]),
		...mapActions("productVariant", ["getProductVariantProgress"]),
	},
	computed: {
		...mapState("user", ["user"]),
		...mapState("productVariant", ["productVariantsProgress"]),

		productVariant() {
			const id = this.$route.params.id;
			return this.user?.productVariants?.find((pv) => pv.id == id) || null;
		},

		progress() {
			const pv = this.productVariant;
			if (!pv) return 0;
			const p = this.productVariantsProgress?.[pv.id];
			if (p && p.totalContent > 0) {
				return Math.round((p.completedTotalContent / p.totalContent) * 100);
			}
			return 0;
		},

		totalModules() {
			const pv = this.productVariant;
			if (!pv) return 0;
			return this.productVariantsProgress?.[pv.id]?.totalContent || 0;
		},

		courseContentURL() {
			const pv = this.productVariant;
			if (!pv) return "/user/dashboard";
			const theme = pv.properties?.contentViewTheme?.toLowerCase();
			if (theme === "ebook") return `/product/dashboard/chapters/${pv.id}`;
			return `/product/content/${pv.id}`;
		},
	},
};
</script>

<style scoped>
.eb-body {
	width: 100%;
}
.course-detail-page__grid {
	display: grid;
	grid-template-columns: 2fr 1fr;
	grid-template-areas:
		"overview  overview"
		"performance sidebar";
	gap: 20px;
	align-items: start;
}

.course-detail-page__overview     { grid-area: overview; }
.course-detail-page__sidebar      { grid-area: sidebar; }
.course-detail-page__performance  { grid-area: performance; }
@media (max-width: 768px) {
	.course-detail-page__grid {
		display: flex;
		flex-direction: column;
		align-items: stretch;
		gap: 16px;
	}

	.course-detail-page__overview,
	.course-detail-page__sidebar,
	.course-detail-page__performance {
		width: 100%;
		min-width: 0;
	}

	.course-detail-page__sidebar     { order: 2; }
	.course-detail-page__overview    { order: 1; }
	.course-detail-page__performance { order: 3; }
}

.course-detail-page__back-link {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	font-size: 14px;
	font-weight: 500;
	color: #374151;
	cursor: pointer;
	margin-bottom: 20px;
	padding: 6px 0;
	transition: color 0.15s;
}

.course-detail-page__back-link:hover {
	color: var(--primary-color, #dc2626);
}

.course-detail-page__not-found {
	text-align: center;
	padding: 80px 0;
	color: #9ca3af;
	font-size: 16px;
}

.course-detail-page__not-found i {
	font-size: 40px;
	margin-bottom: 12px;
	display: block;
}
</style>
